import React, {useRef} from 'react';
import BackgroundImage from './BackgroundImage';
import Header from './Header';
import {AboutMe} from './AboutMe';
import {Projects} from './Projects';
import {Blog} from './Blog';
import {Footer} from './Footer';
import {Contact} from './Contact';
import {Hobbies} from './Hobbies';
import 'bootstrap/dist/css/bootstrap.min.css';
import {MainStyle} from '../assets/css/Styles';
import '../assets/css/Animations.css';

/**
 * @return {Component} header component
 */
function Main() {
  const aboutMeRef = useRef();
  const projectRef = useRef();
  const blogRef = useRef();
  const hobbiesRef = useRef();
  const contactRef = useRef();
  const footerRef = useRef();

  /**
   * @return {function} scroll to about me component
   */
  const handleAboutMeScroll = () => {
    return aboutMeRef.current.scrollIntoView({behavior: 'smooth'});
  };

  /**
   * @return {function} scroll to projects component
   */
  const handleProjectsScroll = () => {
    return projectRef.current.scrollIntoView({behavior: 'smooth'});
  };

  /**
   * @return {function} scroll to blogs component
   */
  const handleBlogScroll = () => {
    return blogRef.current.scrollIntoView({behavior: 'smooth'});
  };

  /**
   * @return {function} scroll to blogs component
   */
  const handleHobbiesScroll = () => {
    return hobbiesRef.current.scrollIntoView({behavior: 'smooth'});
  };

  /**
   * @return {function} scroll to contact component
   */
  const handleContactScroll = () => {
    return contactRef.current.scrollIntoView({behavior: 'smooth'});
  };

  /**
   * @return {function} scroll to footer component
   */
  const handleFooterScroll = () => {
    return footerRef.current.scrollIntoView({behavior: 'smooth'});
  };

  return (
    <div style={MainStyle.container}>
      <BackgroundImage
        scrollToAboutMe={() => handleAboutMeScroll()}
      />
      <Header
        scrollToAboutMe={() => handleAboutMeScroll()}
        scrollToProjects={() => handleProjectsScroll()}
        scrollToBlog={() => handleBlogScroll()}
        scrollToHobbies={() => handleHobbiesScroll()}
        scrollToContact={() => handleContactScroll()}
        scrollToFooter={() => handleFooterScroll()}
      />
      <AboutMe ref={aboutMeRef} />
      <Projects ref={projectRef} />
      <Blog ref={blogRef} />
      <Hobbies ref={hobbiesRef} />
      <Contact ref={contactRef} />
      <Footer ref={footerRef} />
    </div>
  );
}

export default Main;
